// Space Permission Levels
export var SpacePermissionLevel;
(function (SpacePermissionLevel) {
    SpacePermissionLevel["VIEWER"] = "viewer";
    SpacePermissionLevel["EDITOR"] = "editor";
    SpacePermissionLevel["ADMIN"] = "admin";
})(SpacePermissionLevel || (SpacePermissionLevel = {}));
